/* @flow */
import { Set, Record, List, fromJS } from 'immutable';

export type RawOptions = {
  query?: string,
  pageNumber?: number,
  pageSize?: number,
  sortBy?: string,
  sortOrder?: 'ASC' | 'DESC',
};

export const Options = Record({
  query: '',
  pageNumber: 0,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'DESC'
});

export type RawScoreType = {
  scoreType: string,
  displayName: string,
  value: string,
  description: ?string,
};

export type RawScoreItemType = {
  type: string,
  value: string,
  reportGuid: string,
  enclaveGuid: string,
  sourceName: string,
  sourceKey: string,
  updatedDate: string,
  score: RawScoreType,
};

export type ScoresEntryType = Record<RawScoreItemType>;

export const ScoresEntry = Record({
  guid: '',
  pattern: '',
  text: ''
});

// Like payload action but also supports field to update
export type ScoresAction<T> = {
  type: string,
  payload: T,
  field?: string,
  error?: boolean,
  meta?: Object,
};

export type ScoresPageType = {
  pageNumber: number,
  totalPages: number,
  pageSize: number,
  totalElements: number,
  items: Array<ScoresEntry>,
  empty: boolean,
  hasNext: boolean,
};

export const ScoresPage = (pageObject: ScoresPageType) => fromJS(pageObject);

export type ScoresEntries = List<ScoresEntryType>;



// WEBPACK FOOTER //
// ./src/app/modules/entity-scores/types.js